import { Box, CircularProgress, Typography, Backdrop } from "@mui/material";
import { useDesignTokens } from "../../../theme/useDesignTokens";

const FullScreenLoader = ({
  size = 64,
  zIndex = 2500,
  color = "",
  message = "Loading...",
  sx = {},
}) => {
  const { colors, font } = useDesignTokens();

  if (color === "") {
    color = colors?.primary?.main;
  }

  return (
    <Backdrop
      open={true}
      sx={{
        zIndex,
        color: colors?.primary?.text,
        backgroundColor: "rgba(0,0,0,0.4)",
        fontSize: "40px",
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
        <CircularProgress
          size={size}
          sx={{ color }}
          role="status"
          aria-busy={true}
          aria-label={message || "Loading..."}
        />
        <Typography
          variant="body1"
          sx={{ mt: 1, fontSize: font?.size?.fontSz18 }}
        >
          {message}
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default FullScreenLoader;
